var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"answer-block"},[_c('h1',{attrs:{"role":"alert","aria-live":"assertive","tabindex":"0"}},[_vm._v("What forms of payment can I use?")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.payments))])]),_vm._v(" "),_c('base-nav-links')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }